import styled from "@emotion/styled";

export const StyledGuernseyTr = styled.tr`
  height: 50px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.thBorder[0]};
  margin-bottom: 10px;
`;
